import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unslugify',
  standalone: true
})
export class UnSlugifyPipe implements PipeTransform {
  transform(text: string, separator: string = '-'): string {

    text = text.toString().toUpperCase().trim()

    text = text
      .toString()
      .toUpperCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-+/g, " ") // Replace - with space
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, "") // Trim - from end of text

    if (typeof separator !== "undefined" && separator !== "-") {
      text = text.replace(/-/g, separator)
    }

    return text

  }
}